(() => {
  const CARD_SELECTOR = 'product-card[data-tfl-review-count]';
  const BADGE_SELECTOR = '[data-tfl-bestseller-badge]';

  const getGroup = (card) => {
    const type = (card.dataset.tflProductType || '').toLowerCase();
    const title = (card.dataset.tflProductTitle || '').toLowerCase();
    const text = `${type} ${title}`;

    if (text.includes('hoodie')) return 'hoodie';
    if (text.includes('sweatshirt')) return 'sweatshirt';
    if (text.includes('t-shirt') || text.includes('t shirt') || text.includes('tee')) return 'tshirt';
    return null;
  };

  const applyToScope = (scope) => {
    const cards = Array.from(scope.querySelectorAll(CARD_SELECTOR));
    if (!cards.length) return;

    cards.forEach((card) => card.querySelector(BADGE_SELECTOR)?.setAttribute('hidden', ''));

    const groups = { tshirt: [], sweatshirt: [], hoodie: [] };

    cards.forEach((card) => {
      const group = getGroup(card);
      if (group) groups[group].push(card);
    });

    Object.values(groups).forEach((groupCards) => {
      if (!groupCards.length) return;

      const counts = groupCards.map((card) => Number.parseInt(card.dataset.tflReviewCount || '0', 10) || 0);
      const highest = Math.max(...counts);
      let winner;

      if (highest > 0) {
        winner = groupCards[counts.indexOf(highest)];
      } else {
        winner = groupCards[Math.floor(Math.random() * groupCards.length)];
      }

      winner?.querySelector(BADGE_SELECTOR)?.removeAttribute('hidden');
    });
  };

  const applyAll = () => {
    document.querySelectorAll('[data-testid="product-list"]').forEach(applyToScope);
    document.querySelectorAll('collection-component').forEach(applyToScope);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', applyAll, { once: true });
  } else {
    applyAll();
  }

  document.addEventListener('shopify:section:load', applyAll);
})();
